<div class="modal-header">
  <h4 class="modal-title">
    <i class="bi bi-sliders me-2"></i>
    Notenskala konfigurieren
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()">
  </button>
</div>

<div class="modal-body">
  @if (data.caseName) {
    <div class="info-card mb-3">
      <i class="bi bi-info-circle me-2"></i>
      <strong>Fall:</strong> {{ data.caseName }}
    </div>
  }

  @if (data.maxTotalScore && data.maxTotalScore > 0) {
    <div class="info-card info-card--success mb-3">
      <i class="bi bi-trophy me-2"></i>
      <strong>Maximale Gesamtpunktzahl:</strong> {{ data.maxTotalScore }} Punkte
    </div>
  }

  <!-- Toggle Custom Scale -->
  <div class="form-check form-switch mb-4">
    <input class="form-check-input" type="checkbox" role="switch" id="useCustomScaleSwitch"
           [checked]="useCustomScale()"
           (change)="toggleCustomScale()">
    <label class="form-check-label fw-semibold" for="useCustomScaleSwitch">
      Benutzerdefinierte Notenskala verwenden
    </label>
    <small class="form-text text-muted d-block mt-1">
      Wenn deaktiviert, wird der Standard-Notenschlüssel verwendet
    </small>
  </div>

  @if (useCustomScale()) {
    <!-- Grades List -->
    <div class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <label class="form-label fw-semibold mb-0">
          <i class="bi bi-list-ol me-1"></i>
          Standard Notenskala (18-Punkte-System)
        </label>
      </div>

      <div class="grades-container" style="max-height: 400px; overflow-y: auto;">
        @if (grades().length === 0) {
          <div class="info-card info-card--warning">
            <i class="bi bi-exclamation-triangle me-2"></i>
            Keine Noten definiert.
          </div>
        } @else {
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead class="table-light sticky-top">
                <tr>
                  <th style="width: 100px;">Note</th>
                  <th style="width: 150px;">Prozent (%)</th>
                  @if (data.maxTotalScore && data.maxTotalScore > 0) {
                    <th>Absolute Punkte</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (gradeEntry of grades(); track $index) {
                  <tr class="grade-row">
                    <td>
                      <input type="number" class="form-control form-control-sm"
                             [value]="gradeEntry.grade"
                             readonly
                             min="0"
                             max="18"
                             step="1">
                    </td>
                    <td>
                      <div class="input-group input-group-sm">
                        <input type="number" class="form-control"
                               [value]="gradeEntry.percentage"
                               (input)="updateGrade($index, 'percentage', +$any($event.target).value)"
                               min="0"
                               max="100"
                               step="0.1">
                        <span class="input-group-text">%</span>
                      </div>
                    </td>
                    @if (data.maxTotalScore && data.maxTotalScore > 0) {
                      <td>
                        <span class="badge bg-secondary">
                          ≥ {{ getAbsolutePoints(gradeEntry.percentage).toFixed(2) }} P.
                        </span>
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">
    <i class="bi bi-x-circle me-1"></i>
    Abbrechen
  </button>
  @if (useCustomScale()) {
    <button type="button" class="btn btn-outline-secondary" (click)="skipForNow()">
      Später konfigurieren
    </button>
  }
  <button type="button" class="btn btn-primary" (click)="save()">
    <i class="bi bi-check-circle me-1"></i>
    Speichern & Weiter
  </button>
</div>
